interface ErrorDisplayProps {
  error: string;
  onDismiss: () => void;
}

export default function ErrorDisplay({ error, onDismiss }: ErrorDisplayProps) {
  return (
    <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg flex justify-between items-center">
      {error}
      <button onClick={onDismiss} className="underline" aria-label="Dismiss error">
        Dismiss
      </button>
    </div>
  );
}